import { createFileRoute, Link, Outlet, redirect } from '@tanstack/react-router';
import { Shield } from 'lucide-react';
import { SuperAdminOnly } from '@/components/SuperAdminOnly';
import { links } from '@/routes/restaurant/links';

const navLinks = links.find((nl) => nl.name === 'Settings')?.children ?? [];

export const Route = createFileRoute('/r/$restaurantId/s')({
  beforeLoad: ({ context, location, params }) => {
    // Go to general settings by default
    if (location.pathname === `/r/${params.restaurantId}/s`) {
      throw redirect({
        params: { restaurantId: params.restaurantId },
        to: '/r/$restaurantId/s/general-settings',
      });
    }
  },
  component: Component,
});

function Component() {
  return (
    <main className="flex min-h-[calc(100vh-(--spacing(16)))] flex-1 flex-col gap-4 bg-muted/60 dark:bg-muted/20 p-4 md:gap-8 md:p-10">
      <div className="mx-auto grid w-full max-w-6xl gap-2">
        <h1 className="text-3xl font-semibold">Settings</h1>
      </div>
      <div className="mx-auto grid w-full max-w-6xl items-start gap-6 md:grid-cols-[180px_1fr] lg:grid-cols-[250px_1fr]">
        <nav className="grid gap-4 text-sm text-muted-foreground">
          {navLinks.map((navLink) => {
            return (
              <Link
                activeProps={{
                  className: 'font-semibold text-primary',
                }}
                className="flex items-center gap-1"
                key={navLink.name}
                to={navLink.link.to}
              >
                {navLink.isSuperAdminOnly ? (
                  <SuperAdminOnly>
                    <Shield className="h-4 w-4 text-orange-400 fill-orange-100 dark:fill-orange-900" />
                    {navLink.name}
                  </SuperAdminOnly>
                ) : (
                  navLink.name
                )}
              </Link>
            );
          })}
        </nav>
        <div className="grid gap-6">
          <Outlet />

          {/*<Card>*/}
          {/*  <CardHeader>*/}
          {/*    <CardTitle>Plugins Directory</CardTitle>*/}
          {/*    <CardDescription>*/}
          {/*      The directory within your project, in which your plugins are located.*/}
          {/*    </CardDescription>*/}
          {/*  </CardHeader>*/}
          {/*  <CardContent>*/}
          {/*    <form className="flex flex-col gap-4">*/}
          {/*      <Input defaultValue="/content/plugins" placeholder="Project Name" />*/}
          {/*      <div className="flex items-center space-x-2">*/}
          {/*        <Checkbox defaultChecked id="include" />*/}
          {/*        <label*/}
          {/*          className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"*/}
          {/*          htmlFor="include"*/}
          {/*        >*/}
          {/*          Allow administrators to change the directory.*/}
          {/*        </label>*/}
          {/*      </div>*/}
          {/*    </form>*/}
          {/*  </CardContent>*/}
          {/*  <CardFooter className="border-t">*/}
          {/*    <Button>Save</Button>*/}
          {/*  </CardFooter>*/}
          {/*</Card>*/}
        </div>
      </div>
    </main>
  );
}
